import React from "react";
import {
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  TextField,
} from "@mui/material";
import { columnMenuPaper, columnCheckbox } from "../styles";

/**
 * Column visibility menu component
 * Allows users to toggle column visibility and search for columns
 */
const ColumnVisibilityMenu = ({
  anchorEl,
  open,
  onClose,
  columns,
  columnVisibility,
  columnSearchQuery,
  onSearchChange,
  onToggleColumn,
}) => {
  // Filter and sort columns based on search query
  const filteredColumns = React.useMemo(() => {
    const base = columns || [];
    const query = columnSearchQuery?.toLowerCase?.() || "";

    const filtered = query
      ? base.filter((column) =>
          column.header.toLowerCase().includes(query)
        )
      : base;

    // Alphabetically sort by header for better UX
    return [...filtered].sort((a, b) =>
      a.header.localeCompare(b.header, undefined, { sensitivity: "base" })
    );
  }, [columns, columnSearchQuery]);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: columnMenuPaper,
      }}
    >
      <Box sx={{ padding: "5px" }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search columns..."
          value={columnSearchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </Box>
      {filteredColumns.map((column) => (
        <MenuItem
          key={column.accessorKey}
          onClick={() => onToggleColumn(column.accessorKey)}
        >
          <Checkbox
            checked={columnVisibility[column.accessorKey] !== false}
            sx={columnCheckbox}
          />
          <ListItemText primary={column.header} />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ColumnVisibilityMenu;

